export default __webpack_public_path__ + "static/media/apis.5ff6688f.png";